import { useState,useRef } from 'react';
import { createPortal } from 'react-dom';
import { Modal, modalPlacement, modalBackdrop } from 'flowbite';

export default function VideoModal(props: { videoId: string,title: string }) {
    
    const { videoId,title } = props;
    const [openVideoModal, setOpenVideoModal] = useState(false);
    const modalRef = useRef<HTMLDivElement>(null);

    const modalOptions = {
        placement: 'center' as modalPlacement,
        backdrop: 'dynamic' as modalBackdrop,
        backdropClasses: 'modal-backdrop bg-primary-dark/50 fixed inset-0 z-40',
        closable: true,
        onHide: () => {
            const modalBackdrop = document.getElementsByClassName('modal-backdrop')[0];
            if (modalBackdrop) {
                modalBackdrop.remove();
            }
            const modalWrap = modalRef?.current?.getElementsByClassName('video-modal')[0];
            if (modalWrap) {
                while (modalWrap.firstChild) {
                    modalWrap.removeChild(modalWrap.firstChild);
                }
            }
        },
        onShow: () => {
            console.log('modal is shown');
            const iframe = document.createElement('iframe');
            iframe.setAttribute('width', '100%');
            iframe.setAttribute('height', '100%');
            iframe.setAttribute('src', 'https://www.youtube.com/embed/'+videoId+'?&controls=1&autoplay=1&rel=0');
            iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope;');
            iframe.setAttribute('allowFullScreen', 'false');
            iframe.setAttribute('tabIndex', '-1');
            const modalWrap = modalRef.current?.getElementsByClassName('video-modal')[0];
            if (modalWrap) {
                while (modalWrap.firstChild) {
                    modalWrap.removeChild(modalWrap.firstChild);
                }
                modalWrap.appendChild(iframe);
            }
        },
        onToggle: () => {
            console.log('modal has been toggled');
        }
    };

    const playModalVideo = () => {
        setOpenVideoModal(true);
        if (modalRef.current) {
            const modal = new Modal(modalRef.current, modalOptions);
            modal.show();
        }
    }

    const closeModalVideo = () => {
        setOpenVideoModal(false);
        if (modalRef.current) {
            const modal = new Modal(modalRef.current, modalOptions);
            modal.hide();
        }
    }
    

    return (
        <div>
            <a href="#" onClick={() => playModalVideo()}>
                <div className="aspect-video group relative rounded-sm w-full h-auto bg-center bg-cover flex items-center justify-center" style={{backgroundImage:'url(https://img.youtube.com/vi/'+videoId+'/0.jpg)'}}>
                    <div className="bg-primary-light group-hover:bg-primary-light/75 group-hover:scale-125 ring-8 ring-primary-light/25 w-16 h-16 rounded-full flex items-center justify-center transition-all duration-300">
                            <svg className="w-10 h-10 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M8 5v14l11-7z"/>
                            </svg>
                    </div>
                </div>
            </a>
            {createPortal(
                <div ref={modalRef} tabIndex={-1} aria-hidden={openVideoModal} className="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
                    <div className="relative w-full max-w-5xl max-h-full" tabIndex={-1} aria-hidden={openVideoModal}>
                        <div className="relative bg-white p-4 rounded-lg shadow-sm dark:bg-gray-700">
                            <div className="flex items-center justify-between pb-2 lg:pb-4 border-b rounded-t dark:border-gray-600">
                                <h3 className="flex-1 text-sm md:text-lg lg:text-2xl font-semibold text-gray-900 dark:text-white">
                                    {title}
                                </h3>
                                <button onClick={closeModalVideo} type="button" className="text-primary-dark bg-transparent hover:bg-primary-lighter rounded-lg w-8 h-8 ml-auto inline-flex justify-center items-center">
                                    <svg className="w-3 h-3" aria-hidden={openVideoModal} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                                    </svg>
                                    <span className="sr-only">Close Video</span>
                                </button>
                            </div>
                            <div className="video-modal aspect-video w-full h-auto"></div>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </div>
    )
}
